import ApiService, { api as apiService } from "@/services/api/api.service";
import DataTestId from "@/services/data-test-id/data-test-id.service";
import { queryConfig } from "@/services/query/client/client.config";
import QueryKey, { queryKey as queryKeyService } from "@/services/query/key/key.service";
import { QueryClient } from "@tanstack/react-query";
import { ContainerServicesList } from "./container.type";

class Container implements ContainerServicesList {
    private static _instance: Container | undefined = undefined;
    private _api: ApiService;
    private _queryKey: QueryKey;

    private constructor(api: ApiService, queryKey: QueryKey) {
        this._api = api;
        this._queryKey = queryKey;
    }

    public static initialize(api: ApiService = apiService, queryKey: QueryKey = queryKeyService): void {
        if (!this._instance) {
            this._instance = new Container(api, queryKey);
        }
    }

    public static get instance(): Container {
        if (!this._instance) {
            throw new Error("Container is not initialized. Please call initialize() first.");
        }
        return this._instance;
    }

    public get api() {
        return this._api;
    }

    public get queryClient() {
        return new QueryClient(queryConfig);
    }

    public get queryKey() {
        return this._queryKey;
    }

    public get dataTestId() {
        return new DataTestId();
    }
}

Container.initialize();
export const container = Container.instance;
export default Container;
